module.exports = __webpack_public_path__ + "static/media/säck-min.093f6d15.png";